
import {
  POST,
  GET,
  FILE,
  GETPDF
} from '@/axios/axios'

export const services = {
  MissionList: (param) => {   // 支付管理-任务列表
    return GET('/merchant/taskPublish/findTaskPublishByPage', param)
  },
  TaskListExport: (param, rsType) => {   // 支付管理-任务列表-导出
    return GETPDF('/merchant/taskPublish/findTaskPublishExport', param, rsType);
  },
  ModifyingStatus: (param) => {   // 支付管理-任务列表-修改任务状态
    return POST('/merchant/taskPublish/updateTaskStatus', param)
  },
  DeleteTaskList: (param) => {   // 支付管理-任务列表-删除
    return GET('/merchant/taskPublish/delete', param)
  },
  MissionDetails: (param) => {   // 支付管理-任务列表-任务详情
    return GET('/merchant/taskPublish/queryTaskInfoById', param)
  },
  DeleteAcceptor: (param) => {   // 支付管理-任务列表-任务详情-删除承接人
    return GET('/merchant/taskReceiveDetail/delete', param)
  },
  DeleteAllAcceptor: (param) => {   // 支付管理-任务列表-任务详情-全部删除承接人
    return GET('/merchant/taskReceiveDetail/deleteByIds', param)
  },
  NewMission: (param) => {   // 支付管理-新建任务
    return POST('/merchant/taskPublish/saveTaskPublish', param)
  },
  UploadInterface: (param) => {    // 统一上传文件接口
    return FILE("/merchant/upload/uploadFiles", param);
  },
  queryTaskType: () => { // 获取任务类型
    return GET("/merchant/dataDict/queryTaskType");
  },
  updateTaskPublish: (param) => { // 修改任务负责人、联系电话信息
    return POST("/merchant/taskPublish/updateTaskPublish", param);
  },
  checkTaskAccept: (param) => { // 个人承接任务审核
    return POST("/merchant/taskReceiveDetail/checkTaskAccept", param);
  },
  getTaskUserRel: (param) => { // 绑定 任务绑定用户列表
    return GET("/merchant/taskPublish/getTaskUserRel", param);
  },
  putTaskUserRel: (param) => { // 批量更新 任务关联的用户
    return POST("/merchant/taskPublish/putTaskUserRel", param);
  },
  putTaskUserById: (param) => { // 单个更新 任务关联的用户
    return POST("/merchant/taskPublish/putTaskUserRelById", param);
  },
  getIndustryAndSceneLabel: () => {   // 行业分类-服务场景-二级联动
    return GET('/merchant/taskTemplate/getIndustryAndSceneLabel')
  },
  getTaskTemplate: (param) => {   // 任务示例列表
    return GET('/merchant/taskTemplate/getTaskTemplate', param)
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/task-manager.js